export default "__VITE_ASSET__CO4zKELN__"